export const LOCATION_ASSIST_CONFIG_VERSION = "location-assist-1";
export const LOCATION_SOURCE_BROWSER_GEOLOCATION = "browser_geolocation";

const DEFAULT_GEOLOCATION_TIMEOUT_MS = 8000;
const DEFAULT_GEOLOCATION_MAX_AGE_MS = 0;
const DEFAULT_MAX_ACCURACY_RADIUS_M = 500000;
const TRUTHY_FLAG_VALUES = new Set(["1", "true", "yes", "on", "enabled"]);
const FALSY_FLAG_VALUES = new Set(["0", "false", "no", "off", "disabled"]);

function parseBooleanFlag(value, fallback = false) {
  if (value === undefined || value === null) {
    return fallback;
  }

  const normalizedValue = String(value).trim().toLowerCase();
  if (!normalizedValue) {
    return fallback;
  }

  if (TRUTHY_FLAG_VALUES.has(normalizedValue)) {
    return true;
  }

  if (FALSY_FLAG_VALUES.has(normalizedValue)) {
    return false;
  }

  return fallback;
}

function parsePositiveInteger(value, fallback) {
  const parsedValue = Number.parseInt(String(value ?? "").trim(), 10);
  return Number.isFinite(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallback;
}

export function isLocationAssistEnabled(env = process.env) {
  return parseBooleanFlag(env.REACT_APP_PDX_LOCATION_ASSIST_ENABLED, true);
}

export function getGeolocationOptions(env = process.env) {
  return {
    enableHighAccuracy: false,
    timeout: parsePositiveInteger(
      env.REACT_APP_PDX_LOCATION_ASSIST_TIMEOUT_MS,
      DEFAULT_GEOLOCATION_TIMEOUT_MS,
    ),
    maximumAge: DEFAULT_GEOLOCATION_MAX_AGE_MS,
  };
}

export function getMaxAccuracyRadiusMeters(env = process.env) {
  return parsePositiveInteger(
    env.REACT_APP_PDX_LOCATION_ASSIST_MAX_ACCURACY_M,
    DEFAULT_MAX_ACCURACY_RADIUS_M,
  );
}
